/**
 * Empty state component
 */

import React from 'react';
import { typography } from '../../styles/typography';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      {icon && <div className="mb-4 text-theme-text-disabled">{icon}</div>}
      <h3 className={`${typography.cardTitle} mb-2`}>{title}</h3>
      {description && <p className={`${typography.bodySecondary} mb-4 max-w-md`}>{description}</p>}
      {action && <div>{action}</div>}
    </div>
  );
}


